<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<div class="height-100-percent">
    <!-- Design mode. -->
    <div class="flex-row-top-right" *ngIf="this.Mode === 'design'">
        <div class="fill-remaining-space">

            <!-- If there are instructions, display label first, then instructions then field -->
            <ng-container *ngIf="this.HasInstructions">
                <div class="design-mode-field-label" *ngIf="this.DisplayName">{{this.DisplayName}} <span *ngIf="this.FormField.required" style="color:red">*</span></div>
                <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
            </ng-container>

            <kendo-editor name="kendo-editor" [(ngModel)]="this.HtmlValue" style="height: 100%;"></kendo-editor>

            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
    </div>

    <!-- Preview and instance mode. -->
    <div class="flex-row-top-right height-100-percent" *ngIf="(this.Mode === 'preview') || (this.Mode === 'instance')">
        <div class="fill-remaining-space height-100-percent">
            <kendo-editor name="kendo-editor" [(ngModel)]="this.HtmlValue" style="height: 100%;">
            </kendo-editor>

            <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
    </div>
</div>    
